<template>
  <div class="app-select-auto-top-up-type">
    <slot name="txtBefore"></slot>
    <b-form-checkbox-group v-model="selectedTopUp">
      <b-col cols="12" class="auto-top-up-wrapper">
        <b-form-checkbox value="auto" @change="change($event, 'auto')">
          <slot name="txtAutoRadio">Automatische Aufladung</slot>
        </b-form-checkbox>
        <b-form-radio-group required
                            class="top-up-group"
                            v-model="splittedTopUp"
                            v-if="showAutoTopUp"
        >
          <AutoTopUp
            :auto-amounts="autoAmounts"
            :top-up="topUp"
            :trigger.sync="topUp.trigger"
            :amount.sync="topUp.amount"
          >
            <template v-for="slot in possibleChildSlotsFor('AutoTopUp')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </AutoTopUp>
        </b-form-radio-group>
      </b-col>

      <b-col cols="12" class="without-auto-wrapper" v-if="showDeleteAutoTopUp">
        <b-form-checkbox value="without" @change="change($event, 'without')">
          <slot name="txtWithoutRadio">Automatische Aufladung deaktivieren</slot>
        </b-form-checkbox>
      </b-col>
    </b-form-checkbox-group>
    <Stepper
      :show-prev="false"
      @next="next()"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import slotProxy from '@/mixins/slotProxy'
import Stepper from '../../../../../generic/Stepper.vue'
import AutoTopUp from '@/components/process/generic/TopUp/ChangeAutoTopUp/fyve/AutoTopUp.vue'
import preFilledObjectInput from '@/mixins/preFilledObjectInput'
import { mapGetters, mapMutations } from 'vuex'
import preFilledInput from '@/mixins/preFilledInput'

export default {
  name: 'SelectAutoTopUpType',
  components: {
    Stepper,
    AutoTopUp
  },
  computed: {
    showDeleteAutoTopUp () {
      return this.savedTopUp !== null
    },
    showAutoTopUp () {
      return this.selectedTopUp.includes('auto')
    },
    prefilledTopUp () {
      if (this.selectedTopUpData !== null) {
        return this.selectedTopUpData
      }
      if (this.savedTopUp !== null) {
        if (this.savedTopUp.type === 'DAY_OF_MONTH') {
          return {
            type: 'monthly',
            amount: this.savedTopUp.amount,
            trigger: this.savedTopUp.trigger
          }
        }
        return {
          type: 'byLimit',
          amount: this.savedTopUp.amount,
          trigger: this.savedTopUp.trigger
        }
      }
      return {
        trigger: null,
        amount: null,
        type: 'byLimit'
      }
    },
    splittedTopUp: {
      get: function () {
        return {
          type: this.topUp.type
        }
      },
      set: function (value) {
        this.topUp.type = value.type
        if (value.type === 'monthly') {
          this.topUp.trigger = value.trigger
        }
      }
    },
    ...mapGetters('topUp/auto', {
      selectedStoreTopUp: 'selectedTopUp',
      selectedTopUpData: 'selectedTopUpData'
    })
  },
  methods: {
    next () {
      if (this.selectedTopUp.includes('without')) {
        this.storeSelection({
          topUpData: null,
          topUpSelected: ['without']
        })
        this.changeStep({ step: 'deactivateTopUpSummary' })
      } else {
        this.storeSelection({
          topUpData: this.topUp,
          topUpSelected: ['auto']
        })
        this.changeStep({ step: 'activateTopUpSummary' })
      }
    },
    change (newValue, changedItem) {
      if (!this.showDeleteAutoTopUp) {
        this.selectedTopUp = ['auto']
        return
      }
      if (newValue.includes('without') && newValue.length > 1) {
        // invalid!, without + 1 other option
        if (changedItem === 'without') {
          // last change was clicking without -> all other values must be deselected
          this.selectedTopUp = ['without']
        } else {
          this.selectedTopUp = ['auto']
        }
      } else if (newValue.length === 0) {
        if (changedItem === 'without') {
          this.selectedTopUp = ['auto']
        } else {
          this.selectedTopUp = ['without']
        }
      } else {
        this.selectedTopUp = newValue
      }
    },
    ...mapMutations('topUp/auto', [
      'storeSelection',
      'changeStep'
    ])
  },
  mixins: [
    preFilledObjectInput('topUp', 'prefilledTopUp'),
    preFilledInput('selectedTopUp', 'selectedStoreTopUp'),
    slotProxy()
  ],
  props: {
    autoAmounts: {
      type: Object
    },
    savedTopUp: {
      type: Object
    }
  }
}
</script>
